import DMSMainPage from "../../DMSMainPage"
import { Account } from "../login/Account"


export const CustomerLandingPage = () => {

    return (
        <div>
            <Account>
                <div>
                    <DMSMainPage />
                </div>
            </Account>
        </div>
    )
}